module.exports = __webpack_public_path__ + "static/media/microplastic-main-1.c2ad66e4.png";